import { DYNAMIC_PACKAGES } from "../../contexts/SearchContext";

export const CHECKOUT_FLOW_HOTEL = "hotel";
export const CHECKOUT_FLOW_PACKAGE = "package";

/**
 * זיהוי סוג סגירה — מבוסס מודל נתונים בלבד (לא טקסט UI).
 *
 * @param {object} ctx
 * @param {boolean} [ctx.dynamicPackage] — כשמועבר מ־Summary (כבר הוחלט ב־OrderSummery)
 * @param {string|undefined} ctx.searchTab
 * @param {object|null|undefined} ctx.savedDeal
 * @param {string|number|undefined} ctx.dynamicOrderId
 * @param {string|number|undefined} ctx.flightOrderId
 * @returns {'hotel'|'package'}
 */
export function resolveCheckoutFlowType(ctx = {}) {
  if (ctx.dynamicPackage === true) return CHECKOUT_FLOW_PACKAGE;
  if (ctx.dynamicPackage === false) return CHECKOUT_FLOW_HOTEL;

  if (ctx.dynamicOrderId || ctx.flightOrderId) {
    return CHECKOUT_FLOW_PACKAGE;
  }
  if (ctx.searchTab === DYNAMIC_PACKAGES && ctx.savedDeal) {
    return CHECKOUT_FLOW_PACKAGE;
  }
  return CHECKOUT_FLOW_HOTEL;
}

export function isCheckoutPackageFlow(ctx) {
  return resolveCheckoutFlowType(ctx) === CHECKOUT_FLOW_PACKAGE;
}
